import React from "react";
import { TextField } from "@shopify/polaris";

const ActionNameField = ({ input, meta }) => {
  return (
    <TextField
      label="Please give name for your action"
      value={input.value}
      onChange={input.onChange}
      autoComplete="off"
      placeholder="For example: Hide all out of stock products"
      error={meta.error && meta.touched && meta.error}
    />
  );
};

export default ActionNameField;